import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { portfolioConfig } from "../config/portfolio.config";
import { ThemeContext } from "../contexts/ThemeContext";

const Search = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [searchResults, setSearchResults] = useState([]);
  const { darkMode } = useContext(ThemeContext);

  useEffect(() => {
    if (searchQuery) {
      performSearch(searchQuery);
    }
  }, [searchQuery]);

  const performSearch = (query) => {
    const results = [];

    // Search in projects
    const projectResults = portfolioConfig.projects.filter(
      (project) =>
        project.title.toLowerCase().includes(query.toLowerCase()) ||
        project.description.toLowerCase().includes(query.toLowerCase())
    );
    results.push(
      ...projectResults.map((project) => ({ ...project, type: "project" }))
    );

    // Search in skills
    const skillResults = portfolioConfig.skills.filter((skill) =>
      skill.name.toLowerCase().includes(query.toLowerCase())
    );
    results.push(...skillResults.map((skill) => ({ ...skill, type: "skill" })));

    // Search in posts (assuming we have posts in portfolioConfig)
    const postResults = portfolioConfig.posts.filter((post) =>
      post.caption.toLowerCase().includes(query.toLowerCase())
    );
    results.push(...postResults.map((post) => ({ ...post, type: "post" })));

    setSearchResults(results);
  };

  return (
    <div className="max-w-4xl px-4 py-8 mx-auto">
      <h1 className="mb-4 text-2xl font-bold">Search Results</h1>
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search projects, skills, or posts..."
        className="w-full p-2 mb-4 border rounded-md dark:bg-gray-800"
      />
      {searchResults.length > 0 ? (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {searchResults.map((result, index) => (
            <div
              key={index}
              className={`p-4 ${
                darkMode ? "bg-gray-950" : "bg-white"
              } rounded-md shadow`}
            >
              {result.type === "project" && (
                <>
                  <h2 className="text-xl font-semibold">{result.title}</h2>
                  <p className="text-gray-600">{result.description}</p>
                </>
              )}
              {result.type === "skill" && (
                <>
                  <h2 className="text-xl font-semibold">{result.name}</h2>
                  <p className="text-gray-600">Proficiency: {result.level}</p>
                </>
              )}
              {result.type === "post" && (
                <>
                  <img
                    src={result.image}
                    alt={result.caption}
                    className="object-cover w-full h-48 mb-2 rounded"
                  />
                  <p>{result.caption}</p>
                </>
              )}
            </div>
          ))}
        </div>
      ) : searchQuery ? (
        <p>No results found for "{searchQuery}"</p>
      ) : null}
    </div>
  );
};

export default Search;
